/* eslint-disable camelcase */

// node modules
import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import Skeleton from 'react-loading-skeleton';

// app modules: components
import Link from 'components/Link';
import { ListItem } from 'components/List';

// app modules: services
import assets from 'services/assets';
import { getImageSrc, getImageSrcSet } from 'services/image';
import formatter from 'services/formatter';
import route from 'services/route';

// app modules: props
import RelatedContentItemProps from 'components/RelatedContentItem/RelatedContentItemProps';

// assets
import CssRelatedContent from './RelatedContentItem.scss';

const LOG_EXPLANATIONS = false;

class RelatedContentItem extends Component {
  static propTypes = {
    item: RelatedContentItemProps.item,
  };

  static defaultProps = {
    item: {},
  };

  static renderThumbnail(book, instagram, image) {
    if (image) {
      return (
        <figure className="related-content-item__image">
          <img
            src={getImageSrc(image, 'square', size => size.w >= 100)}
            srcSet={getImageSrcSet(image, 'square', [{ x: 1, w: 100 }, { x: 2, w: 200 }])}
            loading="lazy"
            width="65"
            height="65"
            alt=""
          />
        </figure>
      );
    } else if (book.image_name) {
      return (
        <figure className="related-content-item__image">
          <img
            src={assets.coverUrl(book.image_name, {
              resize: 'fit-in',
              width: 130,
              height: 130,
            })}
            loading="lazy"
            width="65"
            height="65"
            alt=""
          />
        </figure>
      );
    }

    return null;
  }

  render() {
    const {
      id,
      authors,
      book,
      title,
      subtitle,
      instagram_url,
      primary_image,
      _explanation,
      skeleton,
    } = this.props.item;

    if (skeleton) {
      return (
        <ListItem key={id} className="related-content-item">
          <Skeleton height="95px" />
        </ListItem>
      );
    }

    const toRenderAuthors = authors && authors.length > 0 ? authors : book.authors;
    const toRenderTitle = title.join(' ');

    if (LOG_EXPLANATIONS && _explanation) {
      // Explanations are usually only generated in development/test envs.
      console.info(`Explanation for ${toRenderTitle}`, JSON.parse(_explanation));
    }

    return (
      <ListItem key={id} className="related-content-item">
        <Link to={route.content(id, title)} className="related-content-item__link">
          {RelatedContentItem.renderThumbnail(book, instagram_url, primary_image)}
          <div className="related-content__item__body">
            <header>
              <div className="heading related-content-item__heading">{toRenderTitle}</div>
              <em className="related-content-item__emphasized">{subtitle}</em>
            </header>
            <p className="related-content-item__paragraph">
              <em className="related-content-item__emphasized">From</em> {book.title}
            </p>
            <p className="related-content-item__paragraph">
              <em className="related-content-item__emphasized">By</em>{' '}
              {formatter.authorsList.toDOM(toRenderAuthors)}
            </p>
          </div>
        </Link>
      </ListItem>
    );
  }
}

export default withStyles(CssRelatedContent)(RelatedContentItem);
